import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
    initializeBlock = function() {

        // sliders
        var splideElements = document.querySelectorAll('.reviews-slider__slider.splide');

        if (splideElements.length > 0) {
            splideElements.forEach(function (splideElement) {
                var options = JSON.parse(splideElement.getAttribute('data-splide'));
                var splide = new Splide(splideElement, options);
                var block = splideElement.closest('.reviews-slider');
                if (!block) {
                    splide.mount();
                    return;
                }
                var previousButton = block.querySelector('.reviews-slider__arrow--prev');
                var nextButton = block.querySelector('.reviews-slider__arrow--next');
                var meta = block.querySelector('.reviews-slider__meta');
                var name = block.querySelector('.reviews-slider__meta .name');
                var heading = block.querySelector('.reviews-slider__meta .review-heading');
                var track = splideElement.querySelector('.splide__track');
                var list = splideElement.querySelector('.splide__list');

                // Writes the active slide's height onto the track. `immediate` skips the
                // CSS height transition, for measurements that are corrections rather
                // than slide changes (initial layout, webfont swap, container resize).
                function updateHeight(index, immediate) {
                    var slide = splide.Components.Slides.getAt(index).slide;
                    var content = slide ? slide.querySelector('.reviews-slider__content') : null;

                    if (!content || !track || !list) {
                        return;
                    }

                    var height = content.offsetHeight;

                    if (!height) {
                        return;
                    }

                    if (immediate) {
                        track.style.transition = 'none';
                        list.style.transition = 'none';
                    }

                    track.style.height = height + 'px';
                    list.style.height = height + 'px';

                    if (immediate) {
                        void track.offsetHeight; // flush, so restoring the transition doesn't animate this change
                        track.style.transition = '';
                        list.style.transition = '';
                    }
                }

                function updateMeta(index) {
                    var slide = splide.Components.Slides.getAt(index).slide;

                    if (!slide || !meta || !name || !heading) {
                        return;
                    }

                    meta.classList.remove('is-changing');

                    requestAnimationFrame(function () {
                        name.textContent = slide.getAttribute('data-author') || '';
                        heading.textContent = slide.getAttribute('data-heading') || '';
                        meta.classList.add('is-changing');
                    });
                }

                if (previousButton) {
                    previousButton.addEventListener('click', function () {
                        splide.go('<');
                    });
                }

                if (nextButton) {
                    nextButton.addEventListener('click', function () {
                        splide.go('>');
                    });
                }

                splide.on('moved', function (newIndex) {
                    updateMeta(newIndex);
                    updateHeight(newIndex);
                });

                splide.on('active', function (slide) {
                    updateHeight(slide.index);
                });

                window.addEventListener('resize', function () {
                    updateHeight(splide.index, true);
                });

                splide.mount();
                updateHeight(splide.index, true);

                // The measurement above can run before the stylesheet and webfont have
                // applied, which would pin the track to a wrong height for good — the
                // slide events only re-measure on navigation. Re-measure whenever the
                // content actually changes size.
                if (window.ResizeObserver) {
                    var resizeObserver = new ResizeObserver(function () {
                        updateHeight(splide.index, true);
                    });

                    splideElement.querySelectorAll('.reviews-slider__content').forEach(function (content) {
                        resizeObserver.observe(content);
                    });
                }

                if (document.fonts && document.fonts.ready) {
                    document.fonts.ready.then(function () {
                        updateHeight(splide.index, true);
                    });
                }
            });
        }
    }
    
    if( window.acf ) {
        // Initialize dynamic block preview (editor).
        window.acf.addAction( 'render_block_preview/type=reviews-slider', initializeBlock );
    } else {
        // Initialize on the frontend.
        initializeBlock();
    }
});
